import { Component, OnInit } from '@angular/core';
import { WidgetService } from '../../widget.service';
import { WidgetDetailInstanceService } from '../widget-detail-instance.service';
import { WidgetMap } from '../../../models/widget';
import { WidgetMapService } from '../../widget-map.service';
import { AlertService } from '../../../core/alert.service';

@Component({
  selector: 'cw-widget-detail-main',
  templateUrl: './widget-detail-main.component.html',
  styleUrls: ['./widget-detail-main.component.scss']
})
export class WidgetDetailMainComponent implements OnInit {
  maps: WidgetMap[];

  constructor(private instance: WidgetDetailInstanceService,
              private mapService: WidgetMapService,
              private widgetService: WidgetService,
              private alert: AlertService) {
    this.instance.$widget.subscribe(widget => {
      if (widget) this.loadMaps();
    });

  }

  ngOnInit() {
  }

  onMapsOrderChange(maps: WidgetMap[]) {
    this.mapService.updateOrder(this.widget, maps)
      .subscribe(
        ok => {
          this.alert.success('Sparat!');
        },
        (err: any) => {
          this.alert.error(err, 'Fel vid sparande');
        });
  }

  onMapNameChange(name: string, map: WidgetMap) {
    map.name = name;
    this.mapService.update(map).subscribe(map => {
      console.log(map);
    });
  }

  onMapAdded(map: WidgetMap) {
    // this.instance.reload();
    this.loadMaps();
  }

  private loadMaps() {
    console.log('loading maps!');
    this.mapService.get(this.widget).subscribe(maps => {
      this.maps = maps;
    });
  }

  get widget() {
    return this.instance.widget;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail-main/widget-detail-main.component.ts